/* TAPORA: apariciones, galería, selector de diseño, encuesta de la tarjeta NFC y barra de compra fija */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.tp-reveal:not(.tp-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('tp-in'); }); return; }
    var vh = window.innerHeight;
    els.forEach(function (e) { if (e.getBoundingClientRect().top < vh * 0.95) e.classList.add('tp-in'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('tp-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
    els.forEach(function (e) { if (!e.classList.contains('tp-in')) io.observe(e); });
  }

  // (2026-10-22) con la foto cambian su descripción (alt) y su encaje: las del proveedor pueden ir enteras (data-fit="contain")
  function setMain(gal, src, btn) {
    var main = gal && gal.querySelector('[data-tp-main]');
    if (!main || !src || main.getAttribute('src') === src) return;
    if (!btn) gal.querySelectorAll('[data-tp-thumb]').forEach(function (b) { if (!btn && b.getAttribute('data-tp-thumb') === src) btn = b; });
    var alt = btn ? btn.getAttribute('data-tp-alt') : null, fit = btn ? btn.getAttribute('data-tp-fit') : null;
    main.style.opacity = 0;
    setTimeout(function () { main.src = src; if (alt) main.alt = alt; if (fit) main.setAttribute('data-fit', fit); main.style.opacity = 1; }, 160);
    gal.querySelectorAll('[data-tp-thumb]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-tp-thumb') === src); });
  }

  // (2026-10-12) En ordenador, la foto grande puede ser la tarjeta del cliente (la pone tp-card-preview.js: .is-live). Tocar
  // una miniatura vuelve a las fotos (y se queda así hasta que pulse "Show my card"); el botón cambia entre las dos.
  function initGallery(root) {
    (root || document).querySelectorAll('[data-tp-gallery]').forEach(function (g) {
      var tg = g.querySelector('[data-tp-gal-toggle]');
      var rotulo = function () { if (tg) tg.textContent = tg.getAttribute(g.classList.contains('is-live') ? 'data-photos' : 'data-show') || tg.textContent; };
      g.querySelectorAll('[data-tp-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (g.classList.contains('is-live')) { g.classList.remove('is-live'); g.setAttribute('data-tp-live-off', ''); rotulo(); }
          var vd = g.querySelector('[data-tp-vid]'); if (vd) { vd.hidden = true; vd.pause(); }
          setMain(g, b.getAttribute('data-tp-thumb'), b);
        });
      });
      if (tg) tg.addEventListener('click', function () {
        var vivo = !g.classList.contains('is-live');
        g.classList.toggle('is-live', vivo);
        if (vivo) g.removeAttribute('data-tp-live-off'); else g.setAttribute('data-tp-live-off', '');
        rotulo();
      });
    });
  }

  // ---------- Tarjeta NFC: encuesta por pasos ----------
  // "kind" = qué hace la tarjeta: wifi (diseño Wi-Fi o Custom logo + Wi-Fi), social (redes), link (Custom logo + "Website or
  // any link") o review (el resto). Con él se enseñan los pasos y campos que tocan, y se marca cada uno Required / Optional.
  var URL_OK = /^https?:\/\/[^\s\/.]+\.[^\s]{2,}$/i;
  var HOSTS_RESENAS = /(^|\.)(g\.page|goo\.gl|google\.[a-z.]+|maps\.app\.goo\.gl|yelp\.[a-z.]+|facebook\.com|fb\.com|tripadvisor\.[a-z.]+|trustpilot\.com|opentable\.com|nextdoor\.com|bbb\.org|angi\.com|thumbtack\.com|zocdoc\.com|healthgrades\.com|vagaro\.com|booksy\.com|styleseat\.com)$/i;
  var FRASE_OK = null;
  try { FRASE_OK = new RegExp('^[\\p{L}\\p{N} .,!?\'’&\\-:@#+()/]+$', 'u'); } catch (e) { FRASE_OK = null; }
  var utf8 = function (s) { try { return new TextEncoder().encode(s).length; } catch (e) { return unescape(encodeURIComponent(s)).length; } };
  // ¿Cabe el QR de este enlace en el reverso de una tarjeta de COLOR? Lo calcula la vista previa con el código de la
  // impresión (window.__tpQr.cabeColor: el QR real + ladoQR + qrCabeEnReverso de colores.mjs). Si aún no se ha cargado, la
  // misma regla contada en bytes: un QR de versión 7 con corrección Q lleva hasta 86 bytes (más ya no cabe).
  var MAX_QR_COLOR = 86;
  function qrCabeColor(v) {
    var r = null;
    try { if (window.__tpQr && window.__tpQr.cabeColor) r = window.__tpQr.cabeColor(v); } catch (e) { r = null; }
    return typeof r === 'boolean' ? r : utf8(v) <= MAX_QR_COLOR;
  }

  function initPers(box, form, pers, chosen) {
    var q = function (s) { return pers.querySelector(s); };
    var qa = function (s) { return pers.querySelectorAll(s); };
    var at = function (k) { return pers.getAttribute('data-' + k) || ''; };
    var lista = function (k) { return at(k).split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean); };
    var link = q('[data-tp-link]'), biz = q('[data-tp-biz]'), err = q('[data-tp-err]');
    var own = q('[data-tp-own]'), ownTxt = q('[data-tp-owntext]'), ownWrap = q('[data-tp-ownwrap]'), ownCount = q('[data-tp-owncount]');
    var notes = q('[data-tp-notes]'), proof = q('[data-tp-proof]'), logoEl = q('[data-tp-logo]');
    var aviso = function () { pers.dispatchEvent(new CustomEvent('tp:pers-change')); };
    var show = function (selector, on) {
      qa(selector).forEach(function (el) {
        el.hidden = !on;
        el.querySelectorAll('input, textarea, select').forEach(function (i) { i.disabled = !on; });
      });
    };
    var setTag = function (el, req) {
      if (!el) return;
      el.textContent = req ? at('tag-req') : at('tag-opt');
      el.classList.toggle('tp-tag--req', req); el.classList.toggle('tp-tag--opt', !req);
    };
    var hint = function (nombre, txt) {
      var el = q('[data-tp-hint="' + nombre + '"]');
      if (el) { el.textContent = txt || ''; el.hidden = !txt; }
    };

    function syncPass() {
      var sec = q('[data-tp-sec]'), wrap = q('[data-tp-passwrap]');
      if (!sec || !wrap || sec.disabled) return;
      var open = sec.value === 'No password';
      wrap.hidden = open;
      wrap.querySelectorAll('input').forEach(function (i) { i.disabled = open; });
      // (red abierta: no hay clave que imprimir; la casilla solo habla de la red)
      var pl = q('[data-tp-printlbl]');
      if (pl) pl.textContent = pl.getAttribute(open ? 'data-open' : 'data-pass') || pl.textContent;
    }
    // la zona del logo: el nombre del archivo elegido y una miniatura (solo en este navegador: no se sube nada aparte)
    var miniUrl = null;
    function syncDrop() {
      var lf = logoEl && logoEl.files && logoEl.files[0];
      var nm = q('[data-tp-dropname]'), sb = q('[data-tp-dropsub]'), th = q('[data-tp-dropthumb]'), dz = q('[data-tp-drop]');
      if (nm) nm.textContent = lf ? lf.name : nm.getAttribute('data-empty') || '';
      if (sb) sb.textContent = sb.getAttribute(lf ? 'data-change' : 'data-empty') || '';
      if (dz) dz.classList.toggle('has-file', !!lf);
      if (th) {
        if (miniUrl) { try { URL.revokeObjectURL(miniUrl); } catch (e) {} miniUrl = null; }
        th.style.backgroundImage = '';
        if (lf && /^image\//i.test(lf.type || '')) { try { miniUrl = URL.createObjectURL(lf); th.style.backgroundImage = 'url("' + miniUrl + '")'; } catch (e) {} }
      }
    }
    function syncOwn() {
      if (!own || !ownTxt) return;
      var on = !own.disabled && own.checked;
      if (ownWrap) ownWrap.hidden = !on;
      ownTxt.disabled = own.disabled;
      own.value = ownTxt.value.replace(/\s+/g, ' ').trim();
      if (ownCount) ownCount.textContent = ownTxt.value.length + '/' + (ownTxt.getAttribute('maxlength') || 26);
    }
    function syncPers() {
      var sel = chosen();
      var has = function (lst) { return sel.some(function (o) { return lst.indexOf((o || '').trim().toLowerCase()) > -1; }); };
      var custom = at('custom').trim().toLowerCase();
      var isCustom = !!custom && has([custom]);
      var isWifi = has(lista('wifi')), isSocial = has(lista('social'));
      var ct = null;
      if (isCustom) { var c = q('[data-tp-ctype]:checked'); ct = c ? c.getAttribute('data-tp-ctype') : 'review'; }
      var kind = isWifi || ct === 'wifi' ? 'wifi' : isSocial || ct === 'social' ? 'social' : ct === 'link' ? 'link' : 'review';
      pers.setAttribute('data-kind', kind);
      pers.setAttribute('data-custom-on', isCustom ? '1' : '0');
      show('[data-tp-step="type"], [data-tp-step="logo"]', isCustom);
      show('[data-tp-step="style"]', isWifi || isSocial || isCustom);
      show('[data-tp-layout]', isCustom && kind !== 'social');
      show('[data-tp-color]', isWifi || isSocial || isCustom);
      show('[data-tp-cnet]', isCustom && kind === 'social');
      show('[data-tp-wifi]', kind === 'wifi');
      show('[data-tp-social]', kind === 'social');
      show('[data-tp-linkwrap]', kind === 'review' || kind === 'link');
      show('[data-tp-phrase]', kind === 'link');
      // dibujos y ayudas del estilo: los de Wi-Fi con "Wi-Fi card"; si no, los de reseñas (en la de enlace, sin estrellas: CSS)
      qa('[data-tp-for]').forEach(function (el) { el.hidden = el.getAttribute('data-tp-for') !== (kind === 'wifi' ? 'wifi' : 'review'); });
      var det = q('[data-tp-step="details"]');
      if (det) { var tt = det.querySelector('[data-tp-step-title]'); if (tt) tt.textContent = det.getAttribute('data-h-' + kind) || tt.textContent; }
      // nombre del negocio: obligatorio donde se imprime (reseñas, enlace); en Wi-Fi y redes, opcional y al final
      var bizReq = kind === 'review' || kind === 'link';
      var bw = q('[data-tp-bizwrap]');
      if (bw) bw.classList.toggle('is-late', !bizReq);
      setTag(q('[data-tp-tag="biz"]'), bizReq);
      if (biz) { if (bizReq) biz.setAttribute('aria-required', 'true'); else biz.removeAttribute('aria-required'); }
      var bh = q('[data-tp-bizhelp]');
      if (bh) bh.textContent = bh.getAttribute(bizReq ? 'data-req' : 'data-opt') || '';
      // el logo: obligatorio en Custom logo, salvo en la tarjeta de enlace (sin logo, se imprime el nombre en su lugar)
      var logoReq = kind !== 'link';
      setTag(q('[data-tp-tag="logo"]'), logoReq);
      if (logoEl) { if (logoReq) logoEl.setAttribute('aria-required', 'true'); else logoEl.removeAttribute('aria-required'); }
      var lgh = q('[data-tp-logohelp]');
      if (lgh) lgh.textContent = logoReq ? lgh.getAttribute('data-req') || '' : ((lgh.getAttribute('data-opt') || '') + ' ' + (lgh.getAttribute('data-req') || '')).trim();
      // la ayuda de las notas: con logo (Custom logo) o de un diseño de stock (sin logo y con sus colores)
      var nh = q('[data-tp-noteshelp]');
      if (nh) nh.textContent = nh.getAttribute(isCustom ? 'data-custom' : 'data-stock') || nh.getAttribute('data-custom') || '';
      // un solo campo de enlace: "Review link" (reseñas) o "Link" (cualquier enlace)
      if (link) {
        var isLink = kind === 'link', lreq = isLink || link.getAttribute('data-req-review') === '1';
        link.name = isLink ? 'properties[Link]' : 'properties[Review link]';
        if (lreq) link.setAttribute('aria-required', 'true'); else link.removeAttribute('aria-required');
        var ll = q('[data-tp-linklbl]'); if (ll) ll.textContent = ll.getAttribute(isLink ? 'data-lbl-link' : 'data-lbl-review') || ll.textContent;
        var lh = q('[data-tp-linkhelp]'); if (lh) lh.textContent = lh.getAttribute(isLink ? 'data-help-link' : 'data-help-review') || '';
        setTag(q('[data-tp-tag="link"]'), lreq);
      }
      syncPass(); syncOwn(); revisarEnlace(false);
      aviso();
    }
    // enlace: https:// si falta (y se dice), y un aviso si no parece una página de reseñas
    var fixUrl = function (input) {
      if (!input) return { v: '', cambiado: false };
      var v = input.value.trim(), antes = v;
      if (v && !/^[a-z][a-z0-9+.-]*:\/\//i.test(v)) v = 'https://' + v;
      if (v !== input.value) input.value = v;
      return { v: v, cambiado: !!antes && v !== antes };
    };
    var httpsDicho = false;
    function revisarEnlace(arreglar) {
      if (!link || link.disabled) { hint('link', ''); errorQR(''); return; }
      if (arreglar) { var r = fixUrl(link); if (r.cambiado) httpsDicho = true; }
      var v = link.value.trim(), txt = [];
      if (httpsDicho && v) txt.push(at('hint-https'));
      if (pers.getAttribute('data-kind') === 'review' && URL_OK.test(v)) {
        var host = ''; try { host = new URL(v).hostname.replace(/^www\./, ''); } catch (e) {}
        if (host && !HOSTS_RESENAS.test(host)) txt.push(at('hint-review-host'));
      }
      hint('link', txt.filter(Boolean).join(' '));
      errorQR(v);
    }
    // ¿Va el QR de este enlace en un reverso de COLOR? 'design' = un diseño de reseñas de color (Sunset...); 'color' = Custom
    // logo de reseñas o de enlace con un "Card color" que no es el clásico (Black & Gold); null = negro (ahí caben los largos)
    function qrEnColor() {
      var kind = pers.getAttribute('data-kind');
      if (kind !== 'review' && kind !== 'link') return null;
      if (pers.getAttribute('data-custom-on') === '1') {
        var c = q('input[name="properties[Card color]"]:checked');
        return c && !c.disabled && !c.hasAttribute('data-tp-classic') ? 'color' : null;
      }
      var colores = Array.prototype.map.call(qa('input[name="properties[Card color]"]:not([data-tp-classic])'), function (i) { return i.value.trim().toLowerCase(); });
      return chosen().some(function (o) { return colores.indexOf((o || '').trim().toLowerCase()) > -1; }) ? 'design' : null;
    }
    // null = cabe (o no aplica); si no, la clave del mensaje: msg-qr-design | msg-qr-color
    function qrNoCabe(v) {
      var donde = qrEnColor();
      if (!donde || !v || !URL_OK.test(v) || qrCabeColor(v)) return null;
      return donde === 'design' ? 'msg-qr-design' : 'msg-qr-color';
    }
    // el aviso sale en el campo en cuanto se sabe (al salir del campo o al cambiar el color), y al comprar no deja seguir
    function errorQR(v) {
      if (!link) return;
      var f = link.closest('.tp-field'), m = f && f.querySelector('[data-tp-msg]');
      if (!f || !m) return;
      var k = link.disabled ? null : qrNoCabe(v);
      if (k) { f.classList.add('is-err'); f.setAttribute('data-tp-qrerr', ''); m.textContent = at(k); m.hidden = false; link.setAttribute('aria-invalid', 'true'); }
      else if (f.hasAttribute('data-tp-qrerr')) { limpiar(link); cajaAlDia(); }
    }
    function revisarNotas() { hint('notes', notes && notes.value.trim() && proof && !proof.checked ? at('hint-notes-proof') : ''); }

    // ---------- errores: en su campo (y en la caja de abajo), y el primero recibe el foco ----------
    function limpiar(campo) {
      var f = campo && campo.closest('.tp-field');
      if (!f) return;
      f.classList.remove('is-err'); f.removeAttribute('data-tp-qrerr');
      var m = f.querySelector('[data-tp-msg]'); if (m) { m.hidden = true; m.textContent = ''; }
      f.querySelectorAll('[aria-invalid]').forEach(function (i) { i.removeAttribute('aria-invalid'); });
    }
    // la caja de error de abajo se va en cuanto no queda ningún campo con error
    function cajaAlDia() { if (err && !err.hidden && !pers.querySelector('.tp-field.is-err')) err.hidden = true; }
    function validar() {
      qa('.tp-field.is-err').forEach(function (f) { limpiar(f.querySelector('input, textarea, select') || f); });
      var kind = pers.getAttribute('data-kind'), errs = [];
      var mal = function (campo, k) { if (campo) errs.push({ campo: campo, msg: at(k) }); };
      var logo = q('[data-tp-logo]');
      if (logo && !logo.disabled) {
        var lf = logo.files && logo.files[0];
        // (tarjeta de enlace: el logo es opcional; sin él se imprime el nombre del negocio)
        if (!lf) { if (kind !== 'link') mal(logo, 'msg-logo'); }
        // (el "accept" del campo es solo una ayuda: un PDF o una foto HEIC no se pueden imprimir como logo)
        else if (!/\.(png|jpe?g|svg|webp)$/i.test(lf.name || '') && !/^image\/(png|jpeg|svg\+xml|webp)$/i.test(lf.type || '')) mal(logo, 'msg-logo-type');
        else if (lf.size > 20 * 1024 * 1024) mal(logo, 'msg-logo-size');
      }
      if ((kind === 'review' || kind === 'link') && biz && !biz.value.trim()) mal(biz, 'msg-required');
      if (link && !link.disabled) {
        var lv = fixUrl(link).v;
        if (kind === 'link') { if (!lv || !URL_OK.test(lv)) mal(link, 'msg-url-link'); else if (lv.length > 400) mal(link, 'msg-link-long'); }
        else if ((link.getAttribute('data-req-review') === '1' && !lv) || (lv && !URL_OK.test(lv))) mal(link, 'msg-link');
        else if (lv.length > 400) mal(link, 'msg-link-long');
        // (2026-10-12) en un reverso de color el QR tiene menos sitio: un enlace demasiado largo no se puede imprimir así
        if (!errs.some(function (x) { return x.campo === link; })) { var kq = qrNoCabe(lv); if (kq) mal(link, kq); }
      }
      if (kind === 'link' && own && own.checked && ownTxt) {
        var t = ownTxt.value.replace(/\s+/g, ' ').trim();
        if (!t) mal(ownTxt, 'msg-phrase');
        else if (!/\b(tap|scan)\b/i.test(t)) mal(ownTxt, 'msg-phrase-tap');
        else if (FRASE_OK && !FRASE_OK.test(t)) mal(ownTxt, 'msg-phrase-chars');
      }
      var ssid = q('[data-tp-ssid]');
      if (ssid && !ssid.disabled) {
        if (!ssid.value.trim()) mal(ssid, 'msg-ssid');
        else if (utf8(ssid.value) > 32) mal(ssid, 'msg-ssid-long');
      }
      var pass = q('[data-tp-pass]');
      if (pass && !pass.disabled) {
        var sv = (q('[data-tp-sec]') || {}).value, pv = pass.value;
        if (!pv || (sv === 'WPA/WPA2/WPA3' && pv.length < 8)) mal(pass, 'msg-pass');
        else if (sv === 'WPA/WPA2/WPA3' && pv.length > 63 && !/^[0-9a-fA-F]{64}$/.test(pv)) mal(pass, 'msg-pass-long');
      }
      var plink = q('[data-tp-plink]');
      if (plink && !plink.disabled) { var pv2 = fixUrl(plink).v; if (!pv2 || !URL_OK.test(pv2) || pv2.length > 400) mal(plink, 'msg-profile'); }
      errs.forEach(function (e) {
        var f = e.campo.closest('.tp-field');
        if (f) { f.classList.add('is-err'); var m = f.querySelector('[data-tp-msg]'); if (m) { m.textContent = e.msg; m.hidden = false; } }
        e.campo.setAttribute('aria-invalid', 'true');
      });
      return errs;
    }
    // Antes de enviar: los campos opcionales vacíos no se mandan (no llegan propiedades vacías al pedido)
    function sinVacios() {
      qa('input[type="text"], input[type="url"], input[type="file"], textarea').forEach(function (i) {
        if (i.disabled || !i.name) return;
        var vacio = i.type === 'file' ? !(i.files && i.files.length) : !i.value.trim();
        if (vacio) { i.disabled = true; i.setAttribute('data-tp-blank', ''); }
      });
    }
    function conVacios() { qa('[data-tp-blank]').forEach(function (i) { i.disabled = false; i.removeAttribute('data-tp-blank'); }); syncPers(); }

    // ---------- vista previa: se carga al llegar a ella (o al empezar a rellenar); si falla, el formulario sigue igual ----------
    var prevRoot = q('[data-tp-prev]'), prevCfg = q('[data-tp-prev-cfg]'), prevCargada = false;
    function vistaNoDisponible() {
      var t = '';
      try { t = JSON.parse(prevCfg.textContent).t.prev_unavailable; } catch (e) {}
      prevRoot.querySelectorAll('[data-tp-face]').forEach(function (el) { el.innerHTML = '<p class="tp-prev__msg"></p>'; el.firstChild.textContent = t; el.classList.add('is-off'); });
    }
    function cargarVista() {
      if (prevCargada || !prevRoot || !prevCfg) return;
      prevCargada = true;
      var cfg;
      try { cfg = JSON.parse(prevCfg.textContent); } catch (e) { return vistaNoDisponible(); }
      var listo = function () { if (window.__tpPrevInit) window.__tpPrevInit(prevRoot, cfg); };
      var modulo = function () {
        if (window.__tpPrevInit) return listo();
        if (document.querySelector('script[data-tp-prev-mod]')) return;
        var m = document.createElement('script');
        m.type = 'module'; m.src = cfg.module; m.setAttribute('data-tp-prev-mod', '');
        m.onerror = vistaNoDisponible;
        document.head.appendChild(m);
      };
      // nada de esto puede bloquear la compra: si en 10 s no hay vista previa, se dice y ya
      setTimeout(function () { if (!prevRoot.hasAttribute('data-tp-prev-ok')) vistaNoDisponible(); }, 10000);
      if (window.qrcode) return modulo();
      var s = document.createElement('script');
      s.src = cfg.qr; s.async = true;
      s.onload = modulo; s.onerror = modulo;   // sin QR, la vista previa sale igual (las caras con QR dirán que no está disponible)
      document.head.appendChild(s);
    }
    if (prevRoot) {
      if ('IntersectionObserver' in window) {
        var pio = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { cargarVista(); pio.disconnect(); } }); }, { rootMargin: '800px 0px' });
        pio.observe(prevRoot);
      } else cargarVista();
      form.addEventListener('input', cargarVista, { once: true });
    }

    // Enlace que llega con la tarjeta ya elegida (p. ej. "Get this card" en los usos de la portada):
    // ?variant=…&card_type=link&card_color=Forest&card_text=Tap to book. Solo marca opciones que existen; si no, no cambia nada.
    // Si marca algo, en ordenador la galería enseña ya esa tarjeta (como si el cliente hubiera empezado la encuesta).
    (function () {
      var pr; try { pr = new URLSearchParams(window.location.search); } catch (e) { return; }
      var hecho = false;
      var igual = function (a, b) { return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase(); };
      var marcar = function (nombre, valor) {
        if (!valor) return false;
        var r = Array.prototype.find.call(qa('input[type="radio"]'), function (i) { return i.name === nombre && i.value && igual(i.value, valor); });
        if (r) { r.checked = true; hecho = true; }
        return !!r;
      };
      var ty = String(pr.get('card_type') || '').replace(/[^a-z]/gi, '').toLowerCase();
      if (ty) { var t = q('[data-tp-ctype="' + ty + '"]'); if (t) { t.checked = true; hecho = true; } }
      marcar('properties[Card color]', pr.get('card_color'));
      var tx = String(pr.get('card_text') || '').replace(/\s+/g, ' ').trim();
      if (tx && !marcar('properties[Card text]', tx) && own && ownTxt) {
        tx = tx.slice(0, +(ownTxt.getAttribute('maxlength') || 26)).trim();
        if (!FRASE_OK || FRASE_OK.test(tx)) { own.checked = true; ownTxt.value = tx; hecho = true; }
      }
      if (!hecho) return;
      pers.setAttribute('data-tp-started', '');
      try { if (window.matchMedia('(min-width: 990px)').matches) cargarVista(); } catch (e) {}
    })();

    // ---------- eventos ----------
    syncPers();
    // (en cuanto el cliente toca la encuesta: en ordenador, la galería enseña su tarjeta -tp-card-preview.js-)
    var empezar = function () { if (!pers.hasAttribute('data-tp-started')) pers.setAttribute('data-tp-started', ''); };
    pers.addEventListener('change', function (e) {
      var t = e.target;
      empezar();
      if (t.hasAttribute('data-tp-ctype')) syncPers();
      if (t.matches('[data-tp-sec]')) syncPass();
      if (t.name === 'properties[Card text]') { syncOwn(); if (own && own.checked && ownTxt) setTimeout(function () { ownTxt.focus(); }, 0); }
      if (t === proof) revisarNotas();
      if (t === logoEl) syncDrop();
      limpiar(t); cajaAlDia();
      // (otro color: el enlace puede dejar de caber -o volver a caber- en el QR)
      if (t.name === 'properties[Card color]') revisarEnlace(false);
    });
    pers.addEventListener('input', function (e) {
      var t = e.target;
      empezar();
      if (t === ownTxt) syncOwn();
      if (t === notes) revisarNotas();
      if (t === link) { httpsDicho = false; hint('link', ''); }
      limpiar(t); cajaAlDia();
    });
    if (link) link.addEventListener('blur', function () { revisarEnlace(true); aviso(); });
    var plinkEl = q('[data-tp-plink]');
    if (plinkEl) plinkEl.addEventListener('blur', function () { fixUrl(plinkEl); aviso(); });
    var user = q('[data-tp-user]');
    if (user) user.addEventListener('blur', function () { var u = user.value.trim().replace(/\s+/g, ' '); if (/^[A-Za-z0-9._-]+$/.test(u)) u = '@' + u; if (u !== user.value) { user.value = u; aviso(); } });
    form.addEventListener('submit', function (e) {
      syncOwn();
      var errs = validar();
      if (errs.length) {
        e.preventDefault();
        err.textContent = errs[0].msg; err.hidden = false;
        var c = errs[0].campo;
        (c.closest('.tp-field') || c).scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        try { c.focus({ preventScroll: true }); } catch (x) { c.focus(); }
        return;
      }
      if (err) err.hidden = true;
      sinVacios();
    });
    // (al volver atrás desde el carrito, el navegador puede devolver la página tal cual: los campos vacíos se reactivan)
    window.addEventListener('pageshow', function () { conVacios(); syncDrop(); });
    syncDrop();
    return { sync: syncPers };
  }

  function initBuy(root) {
    (root || document).querySelectorAll('[data-tp-buy]').forEach(function (box) {
      var form = box.querySelector('form');
      var data = box.querySelector('[data-tp-variants]');
      if (!form || !data) return;
      var variants = JSON.parse(data.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var price = box.querySelector('[data-tp-price]');
      var btn = form.querySelector('button[type="submit"]');
      var gal = box.querySelector('[data-tp-gallery]');
      var groups = box.querySelectorAll('[data-tp-option]');
      var persEl = box.querySelector('[data-tp-pers]');
      function chosen() {
        return Array.prototype.map.call(groups, function (g) {
          if (g.tagName === 'INPUT') return g.value;
          var c = g.querySelector('input:checked'); return c ? c.value : null;
        });
      }
      var pers = persEl ? initPers(box, form, persEl, chosen) : null;
      function update() {
        var sel = chosen();
        if (pers) pers.sync();   // (también vuelve a mirar si el enlace cabe en el QR del diseño nuevo)
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        box.querySelectorAll('[data-tp-current]').forEach(function (s) { var i = +s.getAttribute('data-tp-current'); s.textContent = sel[i] || ''; });
        if (!v) { btn.disabled = true; btn.querySelector('span').textContent = btn.getAttribute('data-na'); return; }
        idInput.value = v.id;
        if (price) price.innerHTML = v.price_html;
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-soldout');
        if (v.image) setMain(gal, v.image);
        // (2026-10-28) miniclip del color elegido encima de la foto (ver tp-buy.liquid)
        var vid = gal && gal.querySelector('[data-tp-vid]');
        if (vid) {
          if (v.video) { if (vid.getAttribute('src') !== v.video) vid.src = v.video; else vid.currentTime = 0; vid.hidden = false; var pl = vid.play(); if (pl && pl.catch) pl.catch(function () {}); }
          else { vid.hidden = true; vid.pause(); }
        }
        // La barra fija es del producto principal: otra caja de compra en la página (p. ej. el expositor en la portada) no cambia su precio
        if (box.hasAttribute('data-tp-main-product')) document.querySelectorAll('[data-tp-sticky-price]').forEach(function (p) { p.innerHTML = v.price_plain; });
        if (window.history && window.history.replaceState && box.hasAttribute('data-tp-main-product')) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }
      box.addEventListener('change', function (e) { if (e.target.closest('[data-tp-option]')) update(); });
      var q = form.querySelector('input[name="quantity"]');
      box.querySelectorAll('[data-tp-qty]').forEach(function (b) {
        b.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-tp-qty'), 10)); });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-tp-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var isProduct = !!document.querySelector('[data-tp-main-product]');
    // En la página de producto se oculta sobre el botón de compra; en otras páginas, sobre cualquier caja de compra (no tapa otro producto y su precio)
    var watch = isProduct ? document.querySelectorAll('.tp-buy__row') : document.querySelectorAll('[data-tp-buy]');
    var ends = document.querySelectorAll('.tp-cta__box, .footer, footer');
    var rowVisible = false, endVisible = 0, seen = [];
    if (watch.length) {
      var rowIO = new IntersectionObserver(function (en) {
        en.forEach(function (e) { var i = seen.indexOf(e.target); if (e.isIntersecting && i < 0) seen.push(e.target); if (!e.isIntersecting && i > -1) seen.splice(i, 1); });
        rowVisible = seen.length > 0; toggle();
      });
      watch.forEach(function (w) { rowIO.observe(w); });
    }
    var endIO = new IntersectionObserver(function (en) { en.forEach(function (e) { endVisible += e.isIntersecting ? 1 : -1; if (endVisible < 0) endVisible = 0; }); toggle(); });
    ends.forEach(function (e) { endIO.observe(e); });
    // (2026-10-12) Página de la tarjeta NFC (con encuesta): mientras se ve la encuesta, la barra NO sale (no tapa los campos
    // ni manda arriba a quien ya la está rellenando). Antes de llegar: "Buy now" baja a la encuesta. Pasada la encuesta: el
    // botón dice "Add to cart" y hace lo mismo que el de comprar (la misma revisión: si falta algo, lleva a ese campo).
    var pers = isProduct ? document.querySelector('[data-tp-main-product] [data-tp-pers]') : null;
    var form = pers && pers.closest('form');
    var sbtn = bar.querySelector('[data-tp-sticky-btn]');
    var donde = 'antes';   // antes | dentro | pasada
    // (2026-10-22) Página de producto SIN encuesta (la plancha): la barra sale solo cuando el botón de compra ya quedó ARRIBA
    // (no al cargar, cuando el botón aún está más abajo: tapaba el aviso de voltaje en el móvil).
    var soloPasado = isProduct && !pers;
    var filas = soloPasado ? Array.prototype.slice.call(watch) : [];
    function pasado() { return filas.some(function (r) { return r.getBoundingClientRect().bottom < 0; }); }
    if (pers && form && sbtn) {
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { donde = e.isIntersecting ? 'dentro' : e.boundingClientRect.top < 0 ? 'pasada' : 'antes'; });
        var t = sbtn.getAttribute(donde === 'pasada' ? 'data-after' : 'data-before');
        if (t) sbtn.textContent = t;
        toggle();
      }).observe(pers);
      sbtn.addEventListener('click', function (e) {
        if (donde !== 'pasada') return;
        e.preventDefault();
        var add = form.querySelector('button[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');
        if (add && add.disabled) { (form.querySelector('.tp-buy__row') || add).scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); return; }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(add || undefined);
        else if (add) add.click();
      });
    }
    // (2026-10-22) Caja de compra SIN encuesta (la plancha): "Buy now" lleva al precio y al botón de añadir al carrito.
    // Antes saltaba al principio de la caja (#tp-buy), que en el móvil es la galería, y el botón quedaba fuera de la pantalla.
    if (!pers && sbtn) {
      sbtn.addEventListener('click', function (e) {
        var href = sbtn.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var dest = document.getElementById(href.slice(1));
        if (!dest || !dest.hasAttribute('data-tp-buy') || dest.querySelector('[data-tp-pers]')) return;
        var top = dest.querySelector('.tp-buy__price') || dest.querySelector('.tp-buy__info');
        var row = dest.querySelector('.tp-buy__row');
        if (!top || !row) return;
        e.preventDefault();
        var hdr = document.querySelector('.section-header');
        var off = (hdr ? Math.min(hdr.getBoundingClientRect().height, 120) : 0) + 16;
        var y = top.getBoundingClientRect().top + window.scrollY - off;
        var rowBottom = row.getBoundingClientRect().bottom + window.scrollY;
        // si del precio al botón no cabe en la pantalla, manda el botón (queda abajo, a la vista)
        if (rowBottom - y > window.innerHeight - 24) y = rowBottom - window.innerHeight + 24;
        window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      });
    }
    function toggle() {
      var show = !rowVisible && endVisible === 0 && (soloPasado ? pasado() : (isProduct || window.scrollY > 520)) && donde !== 'dentro';
      bar.classList.toggle('is-on', show);
      document.documentElement.classList.toggle('tp-sticky-on', show);
    }
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  function init(root) { initReveal(root); initGallery(root); initBuy(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initSticky(); }); else { init(); initSticky(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initSticky(); });
})();
